import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { get } from "lodash";
import mergeEntities from "utils/store/mergeEntities";
import { getSearchPage, getSearchResults } from "store/modules/search";
import { createAPIAction } from "store/actions/api";

// ACTIONS
import facilitySchema from "store/schema/facility";
import unitSchema from "store/schema/unit";
import {
	GET_FACILITY_PAGE_FULFILLED,
	GET_UNIT_ACTION_NAME
} from "./actionTypes";

// Schema for unit page that returns both facility and unit
const unitPageSchema = {
	facility: facilitySchema,
	unit: unitSchema
};

export const getUnit = createAPIAction({
	actionName: GET_UNIT_ACTION_NAME,
	uri: "/api/facility",
	schema: unitPageSchema
});

// =============================================================================
// INITIAL STATE
// =============================================================================

export const initialState = {
	loading: false,
	error: null,
	statusCode: null,
	byId: {}
};

// =============================================================================
// REDUCER
// =============================================================================

const reducers = {};

// =============================================================================
// THUNKS
// =============================================================================

// =============================================================================
// EXTRA REDUCERS
// =============================================================================

const extraReducers = (builder) => {
	builder
		.addMatcher(isAnyOf(getUnit.pending), (state) => {
			state.loading = true;
			state.error = null;
		})
		.addMatcher(isAnyOf(getUnit.fulfilled), (state, action) => {
			const units = get(action, "payload.entities.units") || {};
			state.byId = mergeEntities(state.byId, units);
			state.loading = false;
		})
		.addMatcher(isAnyOf(getUnit.rejected), (state, action) => {
			state.loading = false;
			state.error = action.error;
		})
		.addMatcher(
			(action) =>
				isAnyOf(
					getSearchPage.fulfilled,
					getSearchResults.fulfilled
				)(action) || action.type === GET_FACILITY_PAGE_FULFILLED,
			(state, action) => {
				const units = get(action, "payload.entities.units") || {};
				state.byId = mergeEntities(state.byId, units);
			}
		);
};

// =============================================================================
// SLICE
// =============================================================================

export const unitsSlice = createSlice({
	name: "units",
	initialState,
	reducers,
	extraReducers
});

// =============================================================================
// SELECTORS
// =============================================================================

export const selectUnitById = (state, id) => state.units.byId[id];
export const selectUnitsByIds = (state, ids) =>
	ids.map((id) => selectUnitById(state, id));

export default unitsSlice.reducer;
